import { IS_UXBEAUTY } from 'components/constants/Constants';
import { ProductType } from 'types/Products';

export const getProductPermalink = (
  productType: ProductType,
  productKey: string
) => {
  return `/${
    productType === ProductType.FORMULATIONS && IS_UXBEAUTY
      ? 'concepts'
      : productType.toLowerCase()
  }/permalink/${productKey}`;
};
